import { useEffect, useState } from 'react'
import { useProblemReportState } from '../../lib/problem-reporting/host'
import { createReportSubmission } from './submission'
import { createOwnConfirmation } from './confirmation'
import ReporterSurface, {
  type ReporterProps,
  type ReportControllers,
} from './ReporterSurface'
export type { ReportAdminSurface } from './ReporterSurface'
export default function ProblemReporter(props: ReporterProps) {
  const host = useProblemReportState()
  const [controllers, setControllers] = useState<ReportControllers | null>(null)
  useEffect(() => {
    let cancelled = false
    let owned: ReportControllers | null = null
    void Promise.resolve().then(() => {
      if (cancelled) return
      owned = {
        submission: createReportSubmission(),
        confirmation: createOwnConfirmation(),
      }
      setControllers(owned)
    })
    return () => {
      cancelled = true
      owned?.submission.dispose()
      owned?.confirmation.dispose()
    }
  }, [])
  if (!controllers) return null
  return (
    <ReporterSurface
      key={host.generation}
      {...props}
      controllers={controllers}
    />
  )
}
